import React, {PureComponent} from 'react';
import classNames from 'classnames';
import TextFieldInlineEdit from './TextFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import PropTypes from 'prop-types';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {validateQualityIssueTitle} from '../../utils/validation-helpers';

class TitleInlineEdit extends PureComponent {
  render() {
    const {issue, className, styleType} = this.props;
    const classes = classNames('TitleInlineEdit', className);
    return (
      <TextFieldInlineEdit
        issue={issue}
        attributeName={ISSUE_ATTRIBUTE_NAMES.TITLE}
        className={classes}
        data-testid="TitleInlineEdit"
        styleType={styleType}
        isRequired
        linkify
        inputValidator={validateQualityIssueTitle}
      />
    );
  }
}

TitleInlineEdit.displayName = 'TitleInlineEdit';

TitleInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes))
};

export default TitleInlineEdit;
